"use strict";
var classofRaw = require("../internals/classof-raw");
var uncurryThis = require("../internals/function-uncurry-this");
module.exports = function(fn) {
  if (classofRaw(fn) === "Function") return uncurryThis(fn);
};
